import { ReactNode } from 'react';
import { AnyObjectSchema } from 'yup';
import { nortadaLogger } from '../../logger';
import { nameValidationSchema } from './validators';

interface Payload {
  error: ReactNode;
}

export interface State {
  validation: AnyObjectSchema | undefined;
  currentPage: STEP;
  payload?: Payload;
}

export type Action = { type: STEP; payload?: Payload };

export enum STEP {
  'NAME' = 'NAME',
  'FILTERS' = 'FILTERS',
  'BUSINESS_ERROR' = 'BUSINESS_ERROR'
}

export const initialState = {
  validation: nameValidationSchema,
  currentPage: STEP.NAME
};

export function generateReportReducer(state: State, action: Action, filtersValidationSchema: AnyObjectSchema): State {
  switch (action.type) {
    case STEP.NAME:
      return initialState;
    case STEP.FILTERS:
      return {
        validation: filtersValidationSchema,
        currentPage: STEP.FILTERS
      };
    case STEP.BUSINESS_ERROR:
      return {
        validation: undefined,
        currentPage: STEP.BUSINESS_ERROR,
        payload: action.payload
      };
    default:
      throw nortadaLogger.critical(`${action.type} action is not handled`);
  }
}
